module.exports = __webpack_public_path__ + "static/img/2.bdc190c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/2.png
// module id = U+PJ
// module chunks = 0